import React, { useState } from 'react';

const SmartImage = ({ src, alt, style, className, fallbackIcon = 'fas fa-image' }) => {
  const [currentUrlIndex, setCurrentUrlIndex] = useState(0);
  const [hasError, setHasError] = useState(false);

  const normalizeImageUrl = (raw) => {
    if (!raw) return '';
    let url = String(raw).trim();

    // Handle Google Drive share links → convert to embeddable URL
    const driveIdMatch = url.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/) ||
                         url.match(/[?&]id=([a-zA-Z0-9_-]+)/) ||
                         (/^[a-zA-Z0-9_-]{25,}$/.test(url) ? [null, url] : null);
    if (driveIdMatch && driveIdMatch[1]) {
      return `https://drive.google.com/thumbnail?id=${driveIdMatch[1]}&sz=w400-h400`;
    }

    // Already absolute http(s)
    if (/^https?:\/\//i.test(url)) return url;

    // Normalize backslashes
    url = url.replace(/\\/g, '/');
    // Ensure leading slash for uploads
    if (!url.startsWith('/')) url = `/${url}`;
    // Prepend host for server assets
    return `${url}`;
  };

  const getGoogleDriveUrlFormats = (fileId) => {
    return [
      `https://drive.google.com/thumbnail?id=${fileId}&sz=w600-h600`,
      `https://drive.google.com/thumbnail?id=${fileId}&sz=w400-h400`,
      `https://drive.google.com/thumbnail?id=${fileId}&sz=w200-h200`,
      `https://lh3.googleusercontent.com/d/${fileId}`,
      `https://lh3.googleusercontent.com/d/${fileId}=w400-h400`,
      `https://docs.google.com/uc?export=view&id=${fileId}`,
      `https://drive.google.com/uc?export=view&id=${fileId}`
    ];
  };

  const handleError = () => {
    if (!src) {
      setHasError(true);
      return;
    }

    const normalizedSrc = normalizeImageUrl(src);
    const driveIdMatch = normalizedSrc.match(/id=([a-zA-Z0-9_-]+)/);
    
    if (driveIdMatch && driveIdMatch[1]) {
      const fileId = driveIdMatch[1];
      const urlFormats = getGoogleDriveUrlFormats(fileId);
      
      if (currentUrlIndex < urlFormats.length - 1) {
        setCurrentUrlIndex(currentUrlIndex + 1);
      } else {
        setHasError(true);
      }
    } else {
      setHasError(true);
    }
  };

  const handleLoad = () => {
    // Image chargée avec succès
  };

  if (!src || hasError) {
    return (
      <div 
        className={`smart-image-fallback ${className || ''}`}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          color: '#999',
          fontSize: '24px'
        }}
      >
        <i className={fallbackIcon}></i>
      </div>
    );
  }

  const normalizedSrc = normalizeImageUrl(src);
  const driveIdMatch = normalizedSrc.match(/id=([a-zA-Z0-9_-]+)/);
  
  let currentSrc = normalizedSrc;
  if (driveIdMatch && driveIdMatch[1]) {
    const fileId = driveIdMatch[1];
    const urlFormats = getGoogleDriveUrlFormats(fileId);
    currentSrc = urlFormats[currentUrlIndex] || urlFormats[0];
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      style={style}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
    />
  );
};

export default SmartImage;
